var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    {
      staticClass: "k-actions k-actions-icons actions",
      attrs: { name: "fade", tag: "div" },
    },
    [
      _vm._l(_vm.actions, function (action) {
        return [
          _vm.actionPasses(action) && action.icon && _vm.icons[action.icon]
            ? _c(
                "w-btn-icon",
                {
                  key: action.name,
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.doAction(action)
                    },
                  },
                },
                [
                  _c(_vm.icons[action.icon], {
                    tag: "component",
                    staticClass: "icon",
                    attrs: { title: action.label },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }